<div class="actions-cell">
  @for (action of actions; track $index) {
  <ion-icon class="large" color="primary" [name]="action.icon" (click)="onActionClick(action)"></ion-icon>
  }
</div>
